var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75285 17.0574L0.53863 10.845C0.206978 10.4738 0.0299034 9.98981 0.0437201 9.49224C0.0575368 8.99466 0.261197 8.52123 0.612937 8.16903C0.964677 7.81682 1.43784 7.61254 1.93539 7.59806C2.43294 7.58359 2.91718 7.76003 3.2888 8.09119L6.23152 11.0285L6.23152 2.31837C6.23152 1.80192 6.43668 1.30663 6.80186 0.941439C7.16705 0.576253 7.66235 0.371094 8.1788 0.371094C8.69525 0.371094 9.19055 0.576253 9.55573 0.941439C9.92092 1.30663 10.1261 1.80192 10.1261 2.31837L10.1261 11.0575L13.0979 8.09119C13.2746 7.89337 13.4899 7.73371 13.7305 7.622C13.9711 7.51028 14.232 7.44886 14.4972 7.4415C14.7624 7.43413 15.0263 7.48098 15.2727 7.57917C15.5192 7.67736 15.743 7.82483 15.9304 8.01253C16.1179 8.20024 16.2651 8.42424 16.3629 8.67082C16.4608 8.91739 16.5073 9.18135 16.4996 9.44652C16.4919 9.71169 16.4301 9.9725 16.3181 10.213C16.206 10.4534 16.0461 10.6685 15.848 10.845L9.63381 17.0574C9.45323 17.2385 9.23862 17.3822 9.00231 17.4801C8.76601 17.578 8.51268 17.6282 8.25691 17.6278C8.23511 17.6278 8.21331 17.6278 8.19333 17.6278C7.9269 17.637 7.66143 17.5911 7.41356 17.4929C7.16569 17.3948 6.94076 17.2465 6.75285 17.0574Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.d7a8ffd3dce86130982fadc10a3c5309.svg";
export { ForwardRef as ReactComponent };